let navigateFn = null;

/**
 * Binds the React Router navigate function so it can be used globally.
 * @param {Function} fn - React Router's navigate function
 */
export const setGlobalNavigate = (fn) => {
  navigateFn = fn;
};

/**
 * Navigates to a specific path using the bound React Router function,
 * or falls back to window.location if not initialized.
 * @param {string} path - Target path
 * @param {Object} [options] - React Router navigation options
 */
export const globalNavigate = (path, options) => {
  if (navigateFn) {
    navigateFn(path, options);
  } else {
    window.location.href = path;
  }
};
